import React from "react";
import Extra1 from "../../assets/tradicional/linhatradicional67.jpg";
import Branco from "../../assets/branco.png";

import { Fade, Reveal } from "react-reveal";

const Products = () => {
  const products = PRODUCTS.products;

  return (
    <div
      className="
      grid grid-cols-1 gap-x-36 gap-y-14 mx-10 items-center 
      justify-center 
      sm:grid-cols-1 sm:mx-10 
      md:mx-10 md:grid-cols-2
      lg:mx-28 lg:grid-cols-3 lg:gap-x-10 
            "
    >
      {products.map((item, index) => (
        <Reveal key={index}>
          <Fade bottom big>
            <div className="h-full">
              <div className="bg-white w-full h-full drop-shadow-2xl rounded-md transition ease-in-out hover:-translate-y-1 hover:scale-110">
                <div className="w-full p-7 items-center flex flex-col">
                  <img
                    src={item.image_url}
                    alt=""
                    className="w-full h-48 object-contain"
                  />
                  <div className="w-full mt-10 flex flex-col items-center h-full">
                    <span className="font-poppins font-bold text-preto text-2xl p-1 -mb-2"></span>
                    <span className="font-poppins font-semibold text-preto text-2xl p-1 max-w-max before:block before:absolute before:transform before:translate-y-3 before:inset-0 before:inset-y-2 before:bg-[#FFE719] relative inline-block before:-z-10">
                      {item.name}
                    </span>
                    <span className="font-poppins font-semibold text-preto text-2xl p-1 max-w-max before:block before:absolute before:transform before:translate-y-3 before:inset-0 before:inset-y-2 before:bg-[#FFE719] relative inline-block before:-z-10">
                      <b>Código: </b>
                      {item.Código}
                    </span>
                    <span className="font-poppins font-semibold text-preto text-2xl p-1 max-w-max before:block before:absolute before:transform before:translate-y-3 before:inset-0 before:inset-y-2 before:bg-[#FFE719] relative inline-block before:-z-10">
                      <b>Número: </b>
                      {item.Numero}
                    </span>
                    <span className="font-poppins font-semibold text-preto text-2xl p-1 max-w-max before:block before:absolute before:transform before:translate-y-3 before:inset-0 before:inset-y-2 before:bg-[#FFE719] relative inline-block before:-z-10">
                      <b>Dimensões: </b>
                      {item.Dimensões}
                    </span>

                    <span className="font-poppins font-semibold text-preto text-2xl p-1 max-w-max before:block before:absolute before:transform before:translate-y-3 before:inset-0 before:inset-y-2 before:bg-[#FFE719] relative inline-block before:-z-10">
                      <b>Cod .EAN: </b>
                      {item.COD}
                    </span>
                    <span className="font-poppins font-light text-base text-preto">
                      {item.description || "\u00A0"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Fade>
        </Reveal>
      ))}
    </div>
  );
};

export default Products;

const PRODUCTS = {
  products: [
    {
      name: "Marmita polida",
      Código: "150",
      Numero: "16 X 2",
      Dimensões: "16 CM",
      COD: "7897449701505",
      Capacidade: "0,6 L",
      image_url: Extra1,
    },
    {
      name: "Marmita polida",
      Código: "151",
      Numero: "16 X 3",
      Dimensões: "16 CM",
      COD: "7897449701512",
      Capacidade: "1.0 L ",
      image_url: Extra1,
    },
    {
      name: "Marmita polida",
      Código: "152",
      Numero: "16 X 4",
      Dimensões: "16 CM",
      COD: "7897449701529",
      Capacidade: "1,3 L",
      image_url: Extra1,
    },
    {
      name: "Marmita polida",
      Código: "153",
      Numero: "16 X 5",
      Dimensões: "16 CM",
      COD: "7897449701536",
      Capacidade: "1,6 L",
      image_url: Extra1,
    },
    {
      name: "Marmita polida",
      Código: "154",
      Numero: "16 X 6",
      Dimensões: "16 CM",
      COD: "7897449701543",
      Capacidade: "1,6 L",
      image_url: Extra1,
    },
    {
      name: "Marmita polida",
      Código: "155",
      Numero: "18 X 2",
      Dimensões: "18 CM",
      COD: "7897449701550",
      Capacidade: "1,6 L",
      image_url: Extra1,
    },
    {
      name: "Marmita polida",
      Código: "156",
      Numero: "18 X 3",
      Dimensões: "18 CM",
      COD: "7897449701567",
      Capacidade: "1,6 L",
      image_url: Extra1,
    },
    {
      name: "Marmita polida",
      Código: "157",
      Numero: "18 X 4",
      Dimensões: "18 CM",
      COD: "7897449701574",
      Capacidade: "1,6 L",
      image_url: Extra1,
    },
    {
      name: "Marmita polida",
      Código: "158",
      Numero: "18 X 5",
      Dimensões: "18 CM",
      COD: "7897449701581",
      Capacidade: "1,6 L",
      image_url: Extra1,
    },
    {
      name: "Marmita polida",
      Código: "159",
      Numero: "18 X 6",
      Dimensões: "18 CM",
      COD: "7897449701598",
      Capacidade: "1,6 L",
      image_url: Extra1,
    },
  ],
};
